import { Star, Quote } from "lucide-react";
import { REVIEWS } from "../data/reviews";
import { SITE } from "../data/site";
import { useT } from "../i18n/LanguageContext";

export const Reviews = () => {
  const { t, tObj } = useT();
  const highlights = t("reviewHighlights"); // array

  return (
    <section id="recensioni" data-testid="reviews-section" className="py-24 md:py-32 bg-[var(--ivory)] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-end mb-14">
          <div className="lg:col-span-7">
            <div className="gold-divider justify-start">
              <span className="line" />
              <span className="text-[11px] tracking-[0.3em] uppercase">{t("reviews.kicker")}</span>
            </div>
            <h2 className="mt-6 font-display text-5xl md:text-6xl text-[var(--espresso)] tracking-tight-elegant">
              <span className="italic font-serif-elegant text-[var(--gold-deep)]">{t("reviews.title1")}</span> {t("reviews.title2")}
            </h2>
          </div>
          <div className="lg:col-span-5 flex lg:justify-end">
            <div className="flex items-center gap-5 border border-[var(--sand)] bg-[var(--cream)] px-6 py-4">
              <div className="text-center">
                <div className="font-display text-5xl text-[var(--espresso)]">{SITE.rating.stars}</div>
                <div className="flex justify-center gap-0.5 mt-1 text-[var(--gold-deep)]">
                  {Array.from({length:5}).map((_,i)=>(<Star key={i} className="w-3 h-3" fill="currentColor"/>))}
                </div>
              </div>
              <div className="h-12 w-px bg-[var(--sand)]" />
              <div>
                <div className="font-display text-2xl text-[var(--espresso)]">{SITE.rating.count}</div>
                <div className="text-[11px] uppercase tracking-[0.2em] text-[var(--warm-gray)]">{t("reviews.googleReviews")}</div>
              </div>
            </div>
          </div>
        </div>

        <div className="overflow-hidden mb-14 py-4 border-y border-[var(--sand)]/60">
          <div className="marquee-track">
            {Array.isArray(highlights) && [...highlights, ...highlights].map((h, i) => (
              <span key={i} className="font-serif-elegant italic text-2xl md:text-3xl text-[var(--espresso-soft)] flex items-center gap-12">
                {h}<span className="text-[var(--gold)]">✦</span>
              </span>
            ))}
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {REVIEWS.map((r, i) => (
            <article
              key={i}
              data-testid={`review-card-${i}`}
              className="bg-[var(--cream)] border border-[var(--sand)]/70 p-7 hover:border-[var(--gold)] transition-colors duration-500 relative"
            >
              <Quote className="absolute -top-3 left-6 w-6 h-6 text-[var(--gold)] bg-[var(--ivory)] p-1" />
              <div className="flex gap-0.5 text-[var(--gold-deep)]">
                {Array.from({length:5}).map((_,j)=>(
                  <Star key={j} className="w-3.5 h-3.5" fill={j < r.stars ? "currentColor" : "none"} />
                ))}
              </div>
              <p className="mt-4 text-[var(--espresso-soft)] leading-relaxed text-sm">"{tObj(r.text)}"</p>
              <div className="mt-6 flex items-center gap-3 pt-5 border-t border-[var(--sand)]/70">
                <div className="w-10 h-10 rounded-full bg-[var(--gold-soft)]/40 flex items-center justify-center font-display text-sm text-[var(--gold-deep)]">
                  {r.initials}
                </div>
                <div>
                  <div className="font-display text-base text-[var(--espresso)]">{r.name}</div>
                  <div className="text-[11px] uppercase tracking-wider text-[var(--warm-gray)]">{t(`reviewWhen.${r.whenKey}`)}</div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
